import { DetailCard } from '@/common/components/detail-card/DetailCard.tsx';
import { Trans } from '@lingui/react/macro';
import { PropertyList } from '@/common/components/property-list/PropertyList.tsx';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { formatDateTime } from '@/common/utils/formatDateTime.ts';
import { DispenserDetailResponse, DispenserEvent } from '@/features/dispensers/services/schemas.ts';
import { DispenserStatusChip } from '@/features/dispensers/components/dispenser-status-chip/DispenserStatusChip.tsx';
import { getEventTypeLabel } from '@/features/events/types/EventType.ts';

export interface DispenserStatusCardProps {
  data: DispenserDetailResponse;
  lastEvent: DispenserEvent | null;
}

export const DispenserStatusCard = ({ data, lastEvent }: DispenserStatusCardProps) => {
  return (
    <DetailCard title={<Trans>Current Status</Trans>}>
      <PropertyList>
        <PropertyList.Item
          label={<Trans>Dispenser Status</Trans>}
          value={
            !data.collector ? null : <DispenserStatusChip dispenser={data} lastEvent={lastEvent} />
          }
        />
        <PropertyList.Item
          label={<Trans>Last Update</Trans>}
          value={
            data.lastMessageReceivedAt
              ? formatDateTime(data.lastMessageReceivedAt, 'dateTimeShort')
              : null
          }
        />
        <PropertyList.Item
          label={<Trans>Last Action</Trans>}
          value={
            !lastEvent ? null : (
              <Typography variant="body2" component="span">
                <Chip
                  label={getEventTypeLabel(lastEvent.eventType)}
                  size="small"
                  variant="outlined"
                />
                <Typography mx={1} component="span" color="textDisabled">
                  •
                </Typography>
                <Typography component="span" color="textSecondary" variant="body2">
                  {formatDateTime(lastEvent.eventAt, 'dateTimeShort')}
                </Typography>
              </Typography>
            )
          }
        />
      </PropertyList>
    </DetailCard>
  );
};
